module.exports = __webpack_public_path__ + "static/img/HT4-icon.d0e775f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/refs/ht/HT4-icon.jpg
// module id = FrUT
// module chunks = 0